const baseURL = "/v1/Formacao";

const service = {
  methods: {
    $buscarFormacao(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarFormacao(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarFormacao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarFormacao(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarFormacao(id) {
      return this.$api().patch(`${baseURL}/${id}`, {});
    },
    $excluirFormacao(id) {
      return this.$api().delete(`${baseURL}/${id}`);
    },
    $buscarStatusFormacao() {
      return this.$api().get(`${baseURL}/Situacoes`);
    },
    $obterTurnos() {
      return this.$api().get(`${baseURL}/Turnos`)
    },
    $obterEtapas() {
      return this.$api().get(`${baseURL}/Etapas`)
    },
    $obterRelatorioPDFSolicitacaoFormacao(params) {
      return this.$api().get(`${baseURL}/RelatorioPdf`, this.$getParamsObject(params));
    },
    $Reagendar(body, id) {
      return this.$api().patch(`${baseURL}/Reagendar/${id}`, body);
    },


    // plano de trabalho
    $visualizarAbaPlanoDeTrabalho(id, params) {
      // return this.$api().get(`${baseURL}/AbaProcesso/Visualizar/${id}`, params);
      return this.$api().get(`${baseURL}/${id}`, params);
    },

    // aba programacao
    $cadastrarFormacaoProgramacao(body) {
      return this.$api().post(`${baseURL}/Programacao`, body);
    },
    $visualizarAbaProgramacao(id, params) {
      return this.$api().get(`${baseURL}/Programacao/${id}`, params);
    },
    $visualizarAbaProgramacaoInstrutores(id, params) {
      return this.$api().get(`${baseURL}/Instrutores/${id}`, params);
    },

    //aba orçamento
    $cadastrarFormacaoOrcamento(id, params) {
      return this.$api().post(`${baseURL}/Orcamento/${id}`, params);
    },
    $visualizarAbaOrcamento(id, params) {
      return this.$api().get(`${baseURL}/Orcamento/${id}`, params);
    },

    // Conclusao

    $concluirFormacao(id) {
      return this.$api().patch(`${baseURL}/ConcluirFormacao/${id}`, {});
    },


    //formacao Aprovacao
    $buscarFormacaoAprovacao(params) {
      return this.$api().get(`${baseURL}/FormacaoParaAprovacao`, params);
    },
    $obterRelatorioCSVProgramacao(formacaoId, xlsx = false) {
      return this.$api().get(`${baseURL}/BaixarProgramacao/${formacaoId}`, this.$getParamsObject({params: {xlsx: xlsx}}));
    },
    $solicitarCorrecao(id, aba, params) {
      return this.$api().patch(`${baseURL}/SolicitarCorrecao/${id}/${aba}`, params);
    },
    $consultarStatusLimiteDeAjustes(id) {
      return this.$api().get(`${baseURL}/ConsultarStatusLimiteDeAjustes/${id}`);
    },
    $solicitarAprovacao(id) {
      return this.$api().patch(`${baseURL}/Aprovar/${id}`);
    },
    $justificativaReprovacao(body, id) {
      return this.$api().patch(`${baseURL}/Justiticativa-reprovacao/${id}`, body);
    },
    $AprovarReprovarReagendamento(body, id) {
      return this.$api().patch(`${baseURL}/Aprovar-rejeitar-reagendamento/${id}`, body);
    },

    // consolidacao

    $buscarFormacaoConsolidacao(params) {
      return this.$api().get(`${baseURL}/FormacaoParaConsolidar`, params);
    },
    $solicitarConsolidacao(id, numeroSei){
      return this.$api().patch(`${baseURL}/Consolidar/${id}/${numeroSei}`);
    }
  },
};

export default service;